/* 🤖 this file was generated by svg-to-ts */
export const matIconWysiwyg: {
  name: 'wysiwyg';
  data: string;
} = {
  name: 'wysiwyg',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 16H5V7h14v12zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2z"/></svg>`
};
